import FVirtualList from './index.vue';

export {
    FVirtualList,
};

export default FVirtualList;
